import React, { useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Buttons from "../components/Buttons";
import { MdOutlineMail } from "react-icons/md";
import emailjs from "@emailjs/browser";
import Swal from "sweetalert2";
const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_kkaw7md", "template_e203ddi", form.current, {
        publicKey: "r08KLkIrOA6DHfGZv",
      })
      .then(
        () => {
          console.log("SUCCESS!");
          Swal.fire({
            icon: "success",
            title: "Message Sent!",
            text: "We will get back to you soon.",
          });
          form.current.reset(); // Reset the form after successful submission
        },
        (error) => {
          console.log("FAILED...", error.text);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong! Please try again.",
          });
        }
      );
  };

  return (
    <>
      <section>
        <Container>
          <Row>
            <Col xs="12" className="py-3">
              <div className="contactbanner pad_50">
                <div className="monts text-white service_text">Services</div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="pad_90">
        <Container>
          <Row>
            <Col lg="6" className="py-3">
              <div className="contact-info">
                <MdOutlineMail size="33" />
                <h4 className="py-3"> E-mail</h4>
                <h5>maharaja@skdatatech.com</h5>
                <h5>info@skdatatech.com</h5>
              </div>
            </Col>
            <Col lg="6" className="py-3">
              <div className="contact-info height-3">
                <MdOutlineMail size="33" />
                <h4 className="py-3">Phone</h4>
                <h5>+91 95972 88226</h5>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="pad_90">
        <Container>
          <Row>
            <Col lg="6" className="py-3 align-self-center">
              <img
                src={require("../assest/images/contact.jpg")}
                alt="Contact us"
                className="img-fluid"
              />
            </Col>
            <Col lg="6" className="py-3">
              <div className="py-5 contact-box">
                <form ref={form} onSubmit={sendEmail}>
                  <div className="mb-3">
                    <label htmlFor="user_name" className="form-label">
                      Enter your name
                    </label>
                    <input
                      type="text"
                      name="user_name"
                      id="user_name"
                      className="form-control"
                      required
                    />
                  </div>
                  <Row>
                    <Col md={6} className="mb-3">
                      <label htmlFor="user_email" className="form-label">
                        Email
                      </label>
                      <input
                        type="email"
                        name="user_email"
                        id="user_email"
                        className="form-control"
                        required
                      />
                    </Col>
                    <Col md={6} className="mb-3">
                      <label htmlFor="mobile" className="form-label">
                        Mobile No
                      </label>
                      <input
                        type="tel"
                        name="mobile"
                        id="mobile"
                        className="form-control"
                        required
                      />
                    </Col>
                  </Row>
                  <div className="mb-3">
                    <label htmlFor="message" className="form-label">
                      Message
                    </label>
                    <textarea
                      name="message"
                      id="message"
                      className="form-control"
                      rows="4"
                      required
                    />
                  </div>
                  <div className="text-center">
                    <Buttons
                      type="submit"
                      btnLabel="SUBMIT"
                      className="get-start"
                    />
                  </div>
                </form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Contact;
